<div class="card p-4">
  <div class="card-body d-flex justify-content-between align-items-center">
    <h5 class="card-title text-uppercase">Tabla presuntiva Banca Virtual - Riobamba</h5>
  </div>
  <div class="d-flex">
    <div class="d-flex flex-column p-2 mr-4 text-left">
      <span class="box-title">Fecha de Vencimiento</span>
      <span class="box-subtitle">{{ tablaPresuntiva?.fechaVencimiento }}</span>
    </div>
    <div class="d-flex flex-column p-2 mr-4 text-right">
      <span class="box-title">Valor a Entregar</span>
      <span class="box-subtitle">{{ tablaPresuntiva?.valorEntregar | currency}}</span>
    </div>
    <div class="d-flex flex-column p-2 text-right">
      <span class="box-title">Tasa Total Anual</span>
      <span class="box-subtitle">{{ tablaPresuntiva?.tasaTotalAnual }}</span>
    </div>
  </div>
  <table class="table">
    <thead>
      <tr>
        <th scope="col" class="text-uppercase border-top-none text-right">Cuota</th>
        <th scope="col" class="text-uppercase border-top-none text-right">Capital</th>
        <th scope="col" class="text-uppercase border-top-none text-left">Fecha de Pago</th>
        <th scope="col" class="text-uppercase border-top-none text-right">Interés</th>
        <th scope="col" class="text-uppercase border-top-none text-right">Saldo Reducido</th>
        <th scope="col" class="text-uppercase border-top-none text-right">Seguro</th>
        <th scope="col" class="text-uppercase border-top-none text-right">Total Cuota</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let fila of tablaPresuntiva?.tablaPresuntivaPrestamoParaImpresionDetalles">
        <td class="text-right">{{ fila?.numeroCuota }}</td>
        <td class="text-right">{{ fila?.valorCapital | currency }}</td>
        <td class="text-left">{{ fila?.fechaPago | date: 'dd/MM/yyyy' }}</td>
        <td class="text-right">{{ fila?.valorInteres | currency }}</td>
        <td class="text-right">{{ fila?.saldoCapital | currency }}</td>
        <td class="text-right">{{ fila?.valorSeguro | currency }}</td>
        <td class="text-right">{{ fila?.valorTotal | currency }}</td>
      </tr>
    </tbody>
  </table>
</div>
